import { useEffect, useState } from 'react';
import useGoToNavigation from '../../util/useGotoNavigation';
import { useTranslation } from 'react-i18next';
import { LanguageDropdown } from '../common/LanguageDropdown';
import { userAccount } from '../../types/user/userAccountInterface';
import { useMutation } from "@tanstack/react-query";
import { loginApi } from '../../api/user/UserApi';
import { useUser } from '../../util/userContext/UserContext';
import { useModal } from "../../hooks";

const userReqVal: userAccount = {
    loginId: "",
    password: "",
    passwordChk: "",
}
export const Login = () => {
    const { t } = useTranslation();
    const { goToNavigation } = useGoToNavigation();
    const [userReq, setUserReq] = useState(userReqVal);
    const [isRemember, setIsRemember] = useState(false);
    const [succeed, setSucceed] = useState(true);
    const { handleModal } = useModal();
    const { login } = useUser();

    const loginBtn = () => {
        if (userReq.loginId === "" || userReq.password === "") {
            setSucceed(false)
            return;
        }

        if (isRemember) localStorage.setItem('mdstech_remember_userId', userReq.loginId);
        else localStorage.removeItem('mdstech_remember_userId')

        loginAPiMutate.mutate();
    }

    useEffect(() => {
        if (localStorage.getItem('mdstech_remember_userId')) {
            setUserReq({ ...userReq, loginId: localStorage.getItem('mdstech_remember_userId') || "" })
            setIsRemember(true)
        }
    }, [])

    const loginAPiMutate = useMutation({
        mutationFn: () => loginApi(userReq),
        onSuccess: res => {
            if (res.data.code === "0000") {
                login(res.data.result)

                const base64Data = res.data.result?.accessToken?.split(".")[1];
                const base64 = base64Data?.replace(/-/g, "+").replace(/_/g, "/");
                let jsonPayload = JSON.parse(atob(base64 || ""));
                jsonPayload.authority = JSON.parse(jsonPayload.authority);

                jsonPayload.inOutFlag === 0
                    ? goToNavigation('main/dashboard', "", false)
                    : goToNavigation('purchase/pcs/list', "", false);
            } else {
                setSucceed(false);
            }
        },
        onError: res => {
            handleModal({
                isOpen: true,
                contents: "로그인할 수 없습니다.",
                type: "alert",
            })
        }
    });

    return (
        <>
            <div>
            </div>
            <div className="login_content">
                <div className="login_lang_outer">
                    <LanguageDropdown />

                </div>
                <div className="login_box">
                    <img src={process.env.PUBLIC_URL + "/assets/images/login_logo.png"} alt="" />

                    <div className="frm_login_row">
                        <label className="form-label">{t('login-email-labal')}</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_login_input1.png"} alt="" />
                            </span>
                            <input type="text"
                                className="form-control"
                                value={userReq.loginId}
                                onChange={(e) => setUserReq({ ...userReq, loginId: e.target.value })}
                                placeholder={t('login-email-input')} />
                        </div>
                    </div>

                    <div className="frm_login_row mb-0">
                        <label className="form-label">{t('login-pw-label')}</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_login_input2.png"} alt="" />
                            </span>
                            <input type="password"
                                className="form-control"
                                value={userReq.password}
                                onChange={(e) => setUserReq({ ...userReq, password: e.target.value })}
                                onKeyDown={(e) => e.key === "Enter" ? loginBtn() : ""}
                                placeholder={t('login-pw-input')} />
                        </div>
                    </div>

                    <div className="form-check remember_outer">
                        <input className="form-check-input" type="checkbox" id="chk_remember" checked={isRemember}
                            onClick={() => setIsRemember(!isRemember)} />
                        <label className="form-check-label" htmlFor="chk_remember">{t('login-remember-label')}</label>
                    </div>
                    {!succeed &&
                        <div className="error-messageLogin">{t('login-invalid-msg')}</div>
                    }

                    <button className="btn btn-info btn-lg btn_login"
                        onClick={() => loginBtn()}>{t('login-btn-label')}</button>
                    <ul className="login_links">
                        <li><a href={void (0)}
                            onClick={() => goToNavigation('login/pass_reset1', "", false)}>{t('login-resetpw-label')}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}